export const ACCOUNT_SELECTION_KEY = 'account-entitlements';
export const USER_SELECTION_KEY = 'user-entitlements';

export const ACCOUNT_SECTION_NAME = 'Parent Account Entitlements';
export const USER_SECTION_NAME = 'Custom User Entitlements';

export const NO_ASSIGNED_ACCOUNT_ENTITLEMENT_DESCRIPTION =
    'No entitlements assigned to parent account.';

export const NO_ASSIGNED_USER_ENTITLEMENT_DESCRIPTION =
    'No custom entitlements assigned.';
